import { writable, get } from 'svelte/store';


import { wlc } from '@/config';


const _default = {
	wlc: wlc,
	api: '',
	wso: '',
	welcome: 0,
	loading: false,
	storage: false,
	connect: false,
	websocket: null,
};


const { subscribe, set, update } = writable(Object.assign({}, _default));


export const states = {
	subscribe,

	/* pull */
	pull: prop =>
		prop ? get(states)[prop] : get(states),

	/* push */
	push: value =>
		update(self => Object.assign(self, value)),

	/* reset */
	reset: () =>
		update(self => Object.assign(self, _default)),

	/* isInitialized */
	isInitialized: () =>
		get(states).api && get(states).wso ? true : false,
};
